import Trans from 'next-translate/Trans';
import type { ContestSettings } from '@betterpool/api-types/contests-service';
import { ContestSegmentType, SlateLabelEnum } from '@betterpool/api-types/contests-service';

type PrizesSegmentsFooterProps = {
  segments?: ContestSettings['segments'];
  slateLabel?: SlateLabelEnum;
};

function PrizesSegmentsFooter({
  segments,
  slateLabel = SlateLabelEnum.SLATE,
}: PrizesSegmentsFooterProps) {
  if (segments?.segmentType === ContestSegmentType.MULTI_SLATE) {
    return (
      <Trans
        i18nKey="contest:detail.prizes.segmentedPayouts.footer"
        components={{
          b: <b />,
        }}
      />
    );
  }

  if (segments?.segmentType === ContestSegmentType.SINGLE_SLATE) {
    return (
      <Trans
        i18nKey="contest:detail.prizes.slatePayouts.footer"
        values={{ slateLabel: slateLabel?.toLowerCase() }}
        components={{
          b: <b />,
        }}
      />
    );
  }

  return (
    <Trans
      i18nKey="contest:detail.prizes.resizableContest"
      components={{
        br: <br />,
      }}
    />
  );
}

export default PrizesSegmentsFooter;
